<template>
	<div>
		<div class="member-perks" v-if="computedPerks.length">
			<div class="perk-items">
				<a
					v-for="userPerk in computedPerks"
					class="perk-link"
					:title="userPerk.perk.name"
					@click="selectPerk(userPerk)"
				>
					<ximg
						:src="iconSrc(userPerk)"
						:ariaLabel="userPerk.perk.name"
						role="img"
					/>
				</a>
			</div>
		</div>
		<modal v-if="perkModal" v-model="perkModal" :rootClass="'perk-modal'">
			<div>
				<center>
					<h2 class="level-three-heading">{{ selectedPerk.perk.name }}</h2>
					<div class="perk-description">
						<span>{{ selectedPerk.perk.description }}</span>
						<br>
						<span v-if="validTo">Aktiv t.o.m. {{ validTo }}</span>
					</div>
					<ximg
						class="pixelated"
						:src="largeIconSrc"
						:ariaLabel="selectedPerk.perk.name"
						role="img"
					/>
				</center>
			</div>
		</modal>
	</div>
</template>
<script>
import PHPDate from 'PHPDate';
import { convertToCdnUrl } from 'utils';

export default {
	props: {
		userPerks: {
			type: Array,
			default: null,
		},
	},
	data () {
		return {
			selectedPerk: null,
			perkModal: false,
		};
	},
	computed: {
		computedPerks () {
			return this.userPerks.slice(0, 3);
		},
		validTo () {
			if (! this.selectedPerk.validTo) {
				return null;
			}

			const validTo = PHPDate('Y-m-d', this.selectedPerk.validTo);
			return validTo;
		},
		largeIconSrc () {
			if (! this.selectedPerk) {
				return '';
			}
			return convertToCdnUrl(this.selectedPerk.perk.largeIcon);
		},
	},
	methods: {
		iconSrc (userPerk) {
			return convertToCdnUrl(userPerk.perk.icon);
		},
		selectPerk (userPerk) {
			this.selectedPerk = userPerk;
			this.perkModal = true;
		},
	},
};
</script>
